// === CHUYỂN LANDING (gộp 3 trang thành 1) ===
// click menu item -> hiện .view tương ứng, ẩn các view khác, đồng bộ is-active cả nav PC + mobile.
// dispatch resize để libraryMainsite tính lại scale/height + Swiper recalc khi view vừa hiện.
window.addEventListener("load", function () {
  // nút "đăng ký sớm" ở Frame2 -> view offline (Frame3+4); nút "tham gia" -> view hashtag (Frame7, tab 3)
  // (đăng ký sớm không gắn data-view -> mặc định offline; tham gia gắn data-view="hashtag")
  var links = document.querySelectorAll(
    ".menu__item[data-view], .nav-panel__item[data-view], .MS__sprite-f2-btn-dangkysom, .MS__sprite-f2-btn-thamgia"
  );
  if (!links.length) return;

  function switchView(view) {
    document.querySelectorAll("#MS__wrapper .view").forEach(function (v) {
      var on = v.getAttribute("data-view") === view;
      v.classList.toggle("is-active", on);
      // set thẳng inline display -> THẮNG style="display:none" gắn sẵn trên HTML (inline đè class CSS),
      // nhờ vậy đổi tab vẫn hiện/ẩn đúng dù view giữ nguyên style="display:none" trong markup.
      v.style.display = on ? "block" : "none";
    });
    links.forEach(function (a) {
      a.classList.toggle("is-active", a.getAttribute("data-view") === view);
    });
    // đồng bộ URL theo tab -> user copy link là ra đúng tab (offline/hashtag).
    // dùng replaceState: KHÔNG nhả hashchange (tránh lặp gọi switchView) & không tạo history rác.
    // home -> xoá hash cho URL gọn; view khác -> #<hash tương ứng>.
    var hashFor = { home: "", offline: "offline", hashtag: "hashtagchallenge" };
    var h = hashFor[view];
    var url = window.location.pathname + window.location.search + (h ? "#" + h : "");
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, "", url);
    }
    window.dispatchEvent(new Event("resize")); // lib + Swiper tính lại theo view mới
    // Swiper init LAZY khi view hiện (container đã có width) -> layout slide đúng (3 thẻ), không kẹt 2 thẻ
    if (view === "hashtag" && window.initF7Swiper) window.initF7Swiper();
    if (view === "offline" && window.initF4Swiper) window.initF4Swiper();
    // view offline: gọi ĐỒNG BỘ ngay -> nhân vật được đặt ở điểm A trước khi browser paint (không giật),
    // hàm tự cuộn mượt tới card + chạy animation. Không scrollTo(0,0) trước để tránh jump.
    if (view === "offline" && window.runFrame4Journey) {
      window.runFrame4Journey();
    } else {
      window.scrollTo(0, 0);
    }
  }

  links.forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault(); // chặn href -> không nhảy ra ngoài dù thẻ <a> có href thật
      // ưu tiên data-view trên HTML; 2 nút sprite ở Frame2 không gắn data-view -> map cứng trong JS:
      // "tham gia" -> hashtag (tab 3), "đăng ký sớm" (và mặc định) -> offline
      var view =
        a.getAttribute("data-view") ||
        (a.classList.contains("MS__sprite-f2-btn-thamgia") ? "hashtag" : "offline");
      switchView(view);
      var mb = document.getElementById("nth-gd-navigation-mb");
      if (mb) mb.classList.remove("is-open"); // đóng panel mobile sau khi chọn
    });
  });

  // === DEEP-LINK QUA HASH ===
  // vào URL có #hashtagchallenge (hoặc #hashtag) -> tự mở thẳng tab 3 (hashtag) khi load.
  // dùng hash thay vì path (/hashtagchallenge) để KHỎI cần CDN rewrite & không vỡ đường dẫn asset tương đối.
  // map hash -> view; thêm offline/home cho linh hoạt, view không khớp thì bỏ qua (giữ tab mặc định).
  function viewFromHash() {
    var h = (window.location.hash || "").replace(/^#/, "").toLowerCase();
    if (h === "hashtagchallenge" || h === "hashtag") return "hashtag";
    if (h === "offline") return "offline";
    if (h === "home") return "home";
    return null;
  }
  function applyHash() {
    var v = viewFromHash();
    if (v) switchView(v);
  }
  applyHash(); // áp dụng ngay khi load
  window.addEventListener("hashchange", applyHash); // đổi hash sau đó cũng chuyển tab

  // logo (nav PC + mobile) -> về tab home (Frame1).
  // Trang gộp (index) có .view -> đổi view tại chỗ, chặn href. Trang form (index3/4) không có .view
  // -> để href="index.html" điều hướng bình thường về trang chủ.
  var hasViews = document.querySelectorAll("#MS__wrapper .view").length > 0;
  document
    .querySelectorAll("#nth-gd-navigation .logo, #nth-gd-navigation-mb .logo")
    .forEach(function (logo) {
      logo.addEventListener("click", function (e) {
        if (!hasViews) return; // không phải trang gộp -> theo href về index.html
        e.preventDefault();
        switchView("home");
        var mb = document.getElementById("nth-gd-navigation-mb");
        if (mb) mb.classList.remove("is-open");
      });
    });
});

window.addEventListener("load", function () {
  // panel mobile là behavior tùy biến -> tự toggle class .is-open, không dùng hook lib
  var nav = document.getElementById("nth-gd-navigation-mb");
  if (!nav) return;

  // cả burger lẫn nút X đều dùng chung class js-nav-toggle để bật/tắt
  nav.querySelectorAll(".js-nav-toggle").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      nav.classList.toggle("is-open");
    });
  });

  // bấm vào 1 mục trong panel thì đóng lại
  nav.querySelectorAll(".nav-panel__item, .nav-panel__cta").forEach(function (el) {
    el.addEventListener("click", function () {
      nav.classList.remove("is-open");
    });
  });
});
